<template>
    <div id="main">
        <div id="content">
            <div class="barcode_top top_pin">
            </div>
            <div class="barcode_title">{{$t('enterPIN.EnterPIN')}}</div>
            <div class="barcode_input">
                <input ref="code" autofocus="autofocus" v-model="inputCode" type="text" class="code_input">
                <div class="close" @click="cleanInput"><span></span></div>
            </div>
            <div class="barcode_msg">
                <router-link to="/qrcode?action=checkPinCode">
                    <button class="pin_bt">{{$t('enterPIN.ScanApp')}}</button>
                </router-link>
            </div>
            <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
            <button class="details_bt_b" @click="checkPin()">{{$t('common.Confirm')}}</button>
        </div>
        <div class="curtain" v-if="showCurtain"></div>
        <div class="popup-msg" v-if="showCurtain">
            <div class="popup-msg-text">The order of this PIN code is not belongs to this pickup point. It should be at
                {location name}
            </div>
            <button class="try-again">Try again</button>
        </div>
        <transition name="tipMsg">
            <div class="tip-msg" v-if="showTip">
                {{tipMsg}}
            </div>
        </transition>
    </div>
</template>

<script>
import keyboard from 'keyboard-vue'
import icon_del from '../../../node_modules/keyboard-vue/dist/del.png'
import icon_tab from '../../../node_modules/keyboard-vue/dist/tab_top.png'
import Vue from 'vue'

Vue.use(keyboard)
export default {
  name: 'EnterPIN',
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  data () {
    this.num = 6
    return {
      num: this.num,
      showCurtain: false,
      showTip: false,
      tipMsg: null,
      visible: true,
      layout: 'compact',
      input: null,
      option: { // 显示与隐藏
        show: true
      },
      code: '',
      pinCode: [null, null, null, null, null, null],
      pinCode1: null,
      pinCode2: null,
      pinCode3: null,
      pinCode4: null,
      pinCode5: null,
      pinCode6: null,
      inputCode: null
    }
  },
  mounted () {
    // 解决手机端无法自动聚焦
    // $('input[autofocus="autofocus"]').focus()
    // this.codeFocus()
    // let vue = this
    // // 修复插件图标不显示问题
    // let searchButton = setInterval(function () {
    //   let del = $('.keyboard p .key-delete')
    //   let tab = $('.keyboard p .tab-top')
    //   if (del.length === 1 && tab.length === 1) {
    //     clearInterval(searchButton)
    //     $('.keyboard p .key-delete').css('background', '#d7d7d8 url(' + icon_del + ') no-repeat 50%')
    //     $('.keyboard p .key-delete').css('background-size', '28px 28px')
    //     $('.keyboard p .tab-top').css('background', '#d7d7d8 url(' + icon_tab + ') no-repeat 50%')
    //     $('.keyboard p .tab-top').css('background-size', '28px 28px')
    //   }
    // }, 200)
    // // 监听页面点击
    // document.getElementById('content').onclick = function () {
    //   vue.option.show = false
    //   vue.removeFocus()
    // }
    // 聚焦
    // this.autoFocus()

    this.$refs.code.focus()
  },
  methods: {
    cleanInput () {
      this.inputCode = null
    },
    show () {
      this.option.show = true
      this.autoFocus(true)
    },
    getInputValue (val) {
      if (val === 'delete') {
        this.delete()
      } else {
        if (this.pinCode6 !== null) {
          return
        }
        for (let i = 1; i < 7; i++) {
          let index = 'pinCode' + i
          if (this[index] === null) {
            this[index] = val
            this.autoFocus()
            break
          }
        }
      }
    },
    removeFocus () {
      $('.pin_input').removeClass('code-focus')
    },
    autoFocus (focus = false) {
      if (this.pinCode6 !== null && !focus) {
        this.option.show = false
        this.removeFocus()
        return
      }
      if (focus && this.pinCode6 !== null) {
        this.removeFocus()
        $('.focus6').addClass('code-focus')
        return
      }
      this.removeFocus()
      for (let i = 1; i < 7; i++) {
        let index = 'pinCode' + i
        let current = '.focus' + i
        if (this[index] === null) {
          $(current).addClass('code-focus')
          break
        }
      }
    },
    delete () {
      for (let i = 6; i > 0; i--) {
        let index = 'pinCode' + i
        if (this[index] !== null) {
          this[index] = null
          this.autoFocus()
          break
        }
      }
    },
    checkPin () {
      const vue = this
      // 测试通道
      // let ordersId = '63dfa53e-605a-4068-9647-122a4287262c'
      // vue.$router.push('/order/details?order=' + ordersId + '&action=collectingPointTakeExpress')
      let pin = this.inputCode
      // for (let i = 1; i < 7; i++) {
      //   let index = 'pinCode' + i
      //   pin += this[index]
      // }
      // console.log(pin)
      // console.log(pin.length)
      // if (pin.length !== 6) {
      //   vue.displayTip('请输入完整的PIN')
      //   return false
      // }
      // 验证是否正确
      this.axios({
        method: 'get',
        url: this.api.pinCode + '?pinCode=' + pin
      }).then(function (response) {
        let ordersId = response.data.ordersId
        vue.$router.push('/order/details?order=' + ordersId + '&action=collectingPointTakeExpress' + '&pin=' + pin)
      }).catch(function (error) {
        if (error.data.message) {
          vue.displayTip(error.data.message)
        } else {
          vue.displayTip('Unknow error')
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    displayTip (msg = null) {
      let vue = this
      this.showTip = true
      this.tipMsg = msg
      setTimeout(function () {
        vue.showTip = false
        vue.tipMsg = null
      }, 2000)
    }
  }
}
</script>

<style lang="less" src="../../assets/css/return/entercode.css" scoped>
</style>
<style lang="less" scoped>
    .code {
        /*opacity: 0;*/
    }

    .code-focus {
        border: 3px solid #b8ddfd;
        margin-top: -0.02rem;
    }

    .barcode_input {
        // margin: 0 auto;
        /*margin-top: 0.225rem;*/
        margin-left: 3.33%;
        // width: 100%;
        display: flex;
    }

    .code_input {
        border: none;
        color: #707070;
        height: 0.385rem;
        line-height: 0.385rem;
        font-size: 0.35rem;
        font-weight: 900;
        width: 3.01rem;
        margin-top: 0.185rem;
        margin-left: 0.205rem;
    }

    .barcode_input {
        margin: 0 auto;
        margin-top: 0.225rem;
        background: #FFFFFF;
        width: 3.525rem;
        height: 0.745rem;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
        display: flex;
        position: relative;
        z-index: 1;
    }

    .pin_input {
        background: #FFFFFF;
        width: 14.8%;
        height: 0.745rem;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        display: inline-block;
        margin-left: 1.07%;
        border-radius: 0.05rem;
        text-align: center;
        line-height: 0.745rem;
        font-size: 0.35rem;

        .code_input {
            border: none;
            color: #707070;
            height: 100%;
            line-height: 0.385rem;
            font-size: 0.35rem;
            font-weight: 400;
            font-family: 'Poppins-Regular';
            width: 100%;
            text-align: center;
            border-radius: 0.07rem;
        }
    }

    .barcode_msg {
        width: 3.525rem;
        height: 0.965rem;
        margin: 0 auto;
        margin-top: 0.13rem;
        position: relative;

        .pin_bt {
            padding-left: 15px;
            padding-right: 15px;
            min-width: 1.31rem;
            height: 0.38rem;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
            border-radius: 0.42rem;
            border: none;
            // color: rgba(5, 36, 96, 1);
            color: var(--primary-color);
            line-height: 0.18rem;
            font-size: 0.15rem;
            /*font-weight: bold;*/
            font-family: Poppins-Bold;
            position: absolute;
            bottom: 0.1rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .curtain {
        height: 100%;
        width: 100%;
        background: #0f0f0f;
        opacity: 50%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .popup-msg {
        z-index: 3;
        position: fixed;
        width: 94%;
        left: 3%;
        top: 30%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }

    .popup-msg-text {
        margin-top: 0.2rem;
        text-align: center;
        padding-left: 10%;
        padding-right: 10%;
        font-size: 0.15rem;
        margin-bottom: 0.1rem;
    }

    .try-again {
        width: 82%;
        height: 0.58rem;
        background: linear-gradient(113deg, #052460 0%, #1f9dc5 100%);
        -webkit-box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
    }

    // .tip-msg {
    //     z-index: 3;
    //     position: fixed;
    //     top: 0.1rem;
    //     width: 90%;
    //     margin-left: 2%;
    //     background: rgba(255, 0, 0, 0.4);
    //     border-radius: 0.05rem;
    //     color: #fff;
    //     font-weight: 400;
    //     padding: 0.1rem;
    //     font-size: 0.15rem;
    //     text-align: center;
    //     max-width: 400px;
    // }

    // /*vue 动画CSS*/
    // .tipMsg-enter-active, .tipMsg-leave-active {
    //     transition: opacity .5s;
    // }

    // .tipMsg-enter, .tipMsg-leave-to /* .fade-leave-active below version 2.1.8 */ {
    //     opacity: 0;
    // }

    .keyboard {
        width: 100% !important;
        left: unset !important;
        margin-left: unset !important;
    }

    .keyboard p {
        width: 96%;
    }

    .keyboard .key-delete {
        font-size: 1px;
        background: red !important;
    }

    .close {
        position: absolute;
        z-index: 1;
        right: 0.07rem;
        top: 0.27rem;
        width: 0.21rem;
        height: 0.21rem;
        background: #D6D6D6;
        border-radius: 50%;
    }

    .close:before, .close:after {
        position: absolute;
        left: 0.093rem;
        top: 0.032rem;
        content: ' ';
        height: 0.14rem;
        width: 2px;
        background-color: #FFFFFF;
    }

    .close:before {
        transform: rotate(45deg);
    }

    .close:after {
        transform: rotate(-45deg);
    }
</style>



// WEBPACK FOOTER //
// src/components/Return/EnterPIN.vue